<template>
    <div class="invoice">
        <el-container>
            <el-header>
                <div style="width: 100%;background: #D5E7ED;">
                    <el-tabs v-model="activeIndex" type="card" @tab-click="handletabClick" style="width: 100%">
                        <el-tab-pane label="工程款支付发票" name="first"></el-tab-pane>
                        <el-tab-pane label="费用报销发票" name="second"></el-tab-pane>
                    </el-tabs>
                </div>
                <el-form :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="100px" label="分项合同名称：">
                                <el-input v-model="dataForm.subContractName" placeholder="请输入分项合同名称" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="120px" label="分项合同名编号：">
                                    <el-input v-model="dataForm.subContractSerial" placeholder="请输入分项合同名编号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="纳税人识别号：">
                                    <el-input v-model="dataForm.taxPayerCode" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="发票录入时间：">
                                    <el-date-picker
                                            v-model="dataForm.createTime"
                                            @change="createTimeChange"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button  type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
<!--            <el-tabs v-model="activeName" style="width: 100%" @tab-click="handletabClick">-->
<!--                <el-tab-pane-->
<!--                        v-for="(item, index) in editableTabs"-->
<!--                        :key="index"-->
<!--                        :name="item.name"-->
<!--                        :label="item.label"-->
<!--                ></el-tab-pane>-->
<!--            </el-tabs>-->
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column
                            prop="deptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="subContractName"
                            label="分项合同名称"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="subContractSerial"
                            label="分项合同编码"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billHead"
                            label="发票抬头"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="taxPayerCode"
                            label="纳税人识别号"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="amountWithoutTaxTotal"
                            label="不含税金额（元）"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="100px"
                            prop="taxTotal"
                            label="税额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="amountTotal"
                            label="发票金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="claimedAmountTotal"
                            label="已认领金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="unClaimedAmountTotal"
                            label="未认领金额（元）"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="reimbursedAmountTotal"
                            label="已报销金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="unReimbursedAmountTotal"
                            label="未报销金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getAnalysisListService,
        getDeptListService,
        getProjectListService,
        analysisExportService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "incomeStatistics",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    subContractName:'',
                    subContractSerial:'',
                    billHead:'',
                    taxPayerCode:'',
                    createTime:[],
                    createTimeStart:'',
                    createTimeEnd:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,
                showAdvanceFilter: false,

                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表

                activeIndex: 'first',
                activeName: 'PROJECT_PAY',
                editableTabs: [{
                    label: '工程款支付发票',
                    name: 'PROJECT_PAY'
                }, {
                    label: '费用报销发票',
                    name: 'COST'
                }],
                btnAuthorize: {
                    export: { key: "export", btnEnable: false }
                },
            }
        },
        props: {
            menuCode: {
                type: String
            }
        },
        methods:{
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getInvoiceList();
                this.getDeptList();
            },
            //根据条件查询
            query(){
                this.getInvoiceList();
            },
            reset(){
                this. dataForm = {
                    deptId:'',
                    projectId:'',
                    subContractName:'',
                    subContractSerial:'',
                    billHead:'',
                    taxPayerCode:'',
                    createTime:[],
                    createTimeStart:'',
                    createTimeEnd:'',
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.projectList = [];
                this.getInvoiceList();
            },
            /**
             * 获取列表数据
             * */
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm,
                    billUsage: this.activeName
                }
                getAnalysisListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
            },
            // tabbar切换
            handletabClick(tab, event){
                console.log(this.activeIndex)
                this.dataForm.pageIndex = 1;
                switch (this.activeIndex) {
                    case "first":
                        this.activeName = "PROJECT_PAY";
                        break;
                    case "second":
                        this.activeName = "COST";
                        break;
                }
                this.query();
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
            exportBtn(){

                let paramsData = {
                    ...this.dataForm,
                    billUsage: this.activeName,
                    pageSize: 10000,
                }
                analysisExportService(paramsData).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            createTimeChange(val){
                if(val){
                    this.dataForm.createTimeStart = this.dataForm.createTime[0];
                    this.dataForm.createTimeEnd = this.dataForm.createTime[1];
                }else{
                    this.dataForm.createTimeStart = '';
                    this.dataForm.createTimeEnd = '';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .el-container {
        padding-top: 0;
        .el-header {
            padding: 0;
            form {
                padding-right: 20px;
            }
        }
    }
    /deep/.el-tabs__header {
        padding-right: 0 !important;
        background: #d5e7ed !important;
    }
    /deep/.el-tabs__item.is-active {
        background: #fff !important;
        color: #069dbc !important;
        border-bottom-color: #e4e7ed;
    }

    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
    }
    .operatePanel{
        padding-right: 20px;
    }
</style>
